import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";

import "./timeline.css";

const Timeline = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 100,
      once: false,
    });
  }, []);

  return (
    <div>
      <div className="timeline">
        <div className="containerTimeline left">
          <div
            className="contentTimeline"
            data-aos="fade-right"
            data-aos-anchor-placement="top-bottom"
          >
            <div className="timelineTitle d-flex ">
              <h4 className="mb-2">BUANA SELARAS BERJAYA</h4>
              <p className="mb-2">2017 - 2020</p>
            </div>
            <p>Position : Human Resources (HR)</p>
            <p className="mb-1">Main Jobdesk : </p>
            <p className="mb-0 textTimeline">
              {" "}
              - Conducting tests on job applicants
            </p>
            <p className="mb-0 textTimeline">
              - Checking test results and applicant background
            </p>
            <p className="mb-0 textTimeline"> - Interview job applicants</p>
            <p className="mb-0 textTimeline">
              {" "}
              - Checking and approve employee absences
            </p>
            <p className="mb-0 textTimeline"> - Monitor employee performance</p>
          </div>
        </div>
        <div className="containerTimeline right">
          <div
            className="contentTimeline"
            data-aos="fade-left"
            data-aos-anchor-placement="top-bottom"
          >
            <div className="timelineTitle d-flex ">
              <h4 className="mb-2">ZNF DIGITAL CREATIVE</h4>
              <p className="mb-2">2023 - 2024</p>
            </div>
            <p>Position : Fullstack Programmer</p>
            <p className="mb-1">Main Jobdesk : </p>
            <p className="mb-0 textTimeline">
              - Collaborate with team for application feature needs
            </p>
            <p className="mb-0 textTimeline">
              - Performing Database Analysis & Management
            </p>
            <p className="mb-0 textTimeline">- Front End Developing</p>
            <p className="mb-0 textTimeline">- Back End Developing</p>
            <p className="mb-0 textTimeline">
              - Carry out application testing before entering the production
              stage
            </p>
            <p className="mb-0 textTimeline">- Resolve errors and bugs</p>
          </div>
        </div>
        <div className="containerTimeline left">
          <div
            className="contentTimeline"
            data-aos="fade-right"
            data-aos-anchor-placement="top-bottom"
          >
            <div className="timelineTitle d-flex ">
              <h4 className="mb-2">Freelancer (G37 Team)</h4>
              <p className="mb-2">2020 - Present</p>
            </div>
            <p>Position : Frontend / Fullstack Programmer</p>
            <p className="mb-1">Main Jobdesk : </p>
            <p className="mb-0 textTimeline">
              - Make the application display according to design and responsive
            </p>
            <p className="mb-0 textTimeline">
              - Collaborate with backend for application feature needs
            </p>
            <p className="mb-0 textTimeline">
              {" "}
              - Collaborate with backend using restfull api
            </p>
            <p className="mb-0 textTimeline">
              {" "}
              - Collaborate with teams to monitor and develop applications
            </p>
            <p className="mb-0 textTimeline">
              {" "}
              - Carry out application testing before entering the production
              stage
            </p>
            <p className="mb-0 textTimeline">- Resolve errors and bugs</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
